import { Component, Input } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { CropHealthMapType } from '../crop-health-map-footer.component';
import { CropHealthService } from '@/app/features/services/crop-monitoring/services/crop-health.service';

@Component({
  selector: 'app-crop-health-map-type-legend-modal',
  imports: [SharedModule],
  templateUrl: './crop-health-map-type-legend-modal.component.html',
  styleUrl: './crop-health-map-type-legend-modal.component.less',
})
export class CropHealthMapTypeLegendModalComponent {
  @Input() mapTypes: CropHealthMapType[] = [];
  @Input() selectedMapType: CropHealthMapType;
  @Input() cropHealthMapTypes: CropHealthMapType[] = [];

  constructor(public cropHealthService: CropHealthService) {}
}
